const Students = [
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
    { name: "ABC", progress: 80 },
  ];
  
  export default Students;